// extracted by mini-css-extract-plugin
export default {"sectionContainer":"bejzbol_sectionContainer__UoLWs"};